<template>
  <ul
    :class="customClass"
    role="group"
    :aria-labelledby="labelId"
  >
    <li
      v-for="(option, index) in options"
      :key="`key-${option}`"
      class="option"
    >
      <button
        type="button"
        role="button"
        class="enhancements-card-button"
        :class="{ 'selected': selectedOption === option }"
        :aria-pressed="selectedOption === option ? 'true' : 'false'"
        @click="selectOption(option)"
      >
        <div class="enhancements-card-button-container">
          <span v-if="showIcon" :class="iconClass"/>
          <span class="label-text">{{ option }}</span>
          <span
            v-if="selectedOption === option"
            class="icon-checkmark-gold"
          />
        </div>
      </button>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'SelectableGroup',
    props: {
      options: {
        type: Array,
        required: true
      },
      value: {
        type: String,
        default: null
      },
      labelId: {
        type: String,
        default: 'selection-group'
      },
      customClass: {
        type: String,
        default: 'form'
      },
      iconClass: {
        type: String,
        default: 'icon-clock'
      },
      showIcon: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selectedOption: this.value
      }
    },
    watch: {
      value(newValue) {
        this.selectedOption = newValue
      }
    },
    methods: {
      selectOption(option) {
        this.selectedOption = option
        this.$emit('input', option)
      }
    }
  }
</script>
